// USER STREAM STUFF
export interface GenericStreamList {
  id: string;
  name: string;
  description: string;
  duration: number;
  credits: number;
}
export interface GenericUserStream {
  id: string;
  userId: string;
  variantParentId: string;
  configId: string
  name: string;
  categoryIds: string[];
  industryId: string;
  businessTypeId: string;
  ideaTypeId: string;
  finished: boolean;
  dateCreate: number;
  dateUpdate: number;
}
export interface GenericUserStreamWithProgress extends GenericUserStream {
  currentStepId: string;
  results: GenericUserStreamResult[];
  history: GenericStreamHistoryObject[];
  finished: boolean;
  progressCreated: number;
  progressUpdated?: number;
  progressFinished?: number;
}
export interface GenericUserStreamResult {
  stepId: string;
  name: string;
  type: string;
  variant?: string;
  refId?: string;
  created?: number;
  data: any;
  updated?: number;
  fileId?: string;
  s3SavedFile?: boolean;
  changes?: closingContentChanges[];
  file?: {
    id: string;
    fileName: string;
    fileSize: number;
    dateCreated: number;
  }
}
export interface GenericStreamListForUserSelection {
  id: string;
  name: string;
  description: string;
  categoryId: string[]
  type: string;
  promotionArea: PromotionAreaObject;
  dateCreate: number;
  dateUpdate: number;
  credits: number;
  duration: number;
  status: string;
  stepCount: number;
  globalStream: 0 | 1;
}
export interface GenericStreamListForUserUse {
  id: string;
  name: string;
  description: string;
  categoryId: string[]
  type: string;
  promotionArea: PromotionAreaObject;
  dateCreate: number;
  dateUpdate: number;
  credits: number;
  duration: number;
  status: string;
  steps: GenericStepConfig[] | GenericStepConfigForFrontend[];
  globalStream: boolean;
  streamResults: StreamClosingResult[];
}
export interface GenericStepConfigForFrontend {
  id: string;
  name: string;
  description: string;
  duration: number;
  credits: number;
  websearchStatus: boolean;
  uploadStatus: boolean;
  keyQuestions: KeyQuestion[];
  requiredStepIds: string[];
  websearch?: { title: string, source: string, description: string }[]

}
export interface GenericStreamTag {
  id: string,
  name: string,
  status: string
}
export interface GenericStepConfig {
  id: string;
  name: string;
  description: string;
  duration: number;
  credits: number;
  websearchStatus: boolean;
  websearch?: WebsearchQuestion[]
  uploadStatus: boolean;
  upload?: {
    resultPrompt: string;
  }
  agentId: string | null;
  agentPrompt: string;
  closingPromptId: string;
  keyQuestions: KeyQuestion[];
  requiredStepIds: string[]; // Default all
  stepGoal: string;
}
export interface closingContentChanges {
  time: number;
  elementId: string;
  type: ClosingContentChangeType;
  from: string;
  to: string;
}

export enum ClosingContentChangeType {
  TEXT = "text",
  IMAGE = "image",
  OTHER = "other"
}


// BACKEND  STUFF ToDo: check if notwendig
export interface AddGenericStreamFormData {
  id: string | null;
  name: string;
  description?: string;
  categoryId?: string[];
  status: GenericStreamStatus;
  type: GenericStreamType;
  connectedStreamIds: string[];
  llmId: string;
  dateCreate?: number;
  dateUpdate?: number;
  creatingUserId?: string;
  creatingUserPrename?: string;
  creatingUserLastname?: string;
  updatingUserPrename?: string;
  updatingUserLastname?: string;
  updatingUserId?: string;
  promotionArea: PromotionAreaObject;
  streamGoal?: string;
}

export interface Category {
  dateCreated: number;
  dateUpdated: number;
  description: string | null;
  id: string;
  image: string;
  name: string;
  orderNr: number;
  parentId: string | null;
  status: string;
  tags: CategoryTag[]
}
export interface CategoryTree {
  id: string;
  name: string;
  orderNr: number
  children: CategoryTree[];
  streams?: GenericStreamListForUserSelection[];
}

export interface CategoryTag {
  icon: string;
  id: string;
  name: string;
  tagGroupId: string;
}

export interface PromotionAreaObject {
  status: boolean;
  imgStatus: boolean | null;
  imgUrl: string | null;
  headline: string | null;
  description: string | null;
  targetUrl: string | null;
  videos: VideoObject[];
}
export interface VideoObject {
  url: string;
  title: string;
  thumbnail: string;
  description: string;
}
export interface GenericStream extends AddGenericStreamFormData {
  credits: number;
  duration: number;
  steps?: GenericStepConfig[];
}

export enum GenericStreamStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  PENDING = 'pending',
  EXPERIMENTAL = 'experimental'
}
export enum GenericStreamType {
  PROFESSIONAL = "professional",
  BASIC = "basic",
  FREE = "free",
}
export enum GenericChatTypesUi {
  CHAT = "CHAT",
  STANDALONE = "STANDALONE",
  CLOSING = "CLOSING",
  INITIALIZE = "INITIALIZE",
  DOC_UPLOAD = "DOC_UPLOAD"
}

export interface StreamClosingResult {
  orderNumber: number;
  title: string;
  type: StreamClosingType['id'];
}

export interface GenericStepConfigList {
  id: string;
  name: string;
  description: string;
  duration: number;
  credits: number;
}



export interface WebsearchQuestion {
  title: string;
  query: string;
  description: string
  source: string;
}
export interface KeyQuestion {
  title: string;
  question: string;
  description: string;
}
export interface KeyQuestionUi extends KeyQuestion {
  resolved: boolean;
  active: boolean;
}
export interface GenericStreamHistoryObject {
  stepId: string;
  chat: ChatObject[];
  keyQuestions: KeyQuestionUi[];
  threadId?: string;
  briefingMaterial?: string;
}
export interface ChatObject {
  id: string;
  textType: TextType;
  responseType?: ResponseType;
  text?: string;
  suggestion?: any;
  hidden: boolean;
  finished: boolean;
  mediaUrl?: string;
  uploadBtn?: boolean;
  keyQuestion?: number;
  aiRunning?: boolean;

  skipToNextQuestionBtn?: boolean
}
export enum TextType {
  USER = "USER",
  AI = "AI"
}

export enum ResponseType {
  TEXT = "TEXT",
  IMAGE = "IMAGE",
  VIDEO = "VIDEO",
  SUGGESTION = "SUGGESTION"
}
export interface StreamOrderItem {
  categoryId: string,
  streamId: string,
  orderNr: number
}
export interface StreamClosingType {
  id: string;
  name: string;
}
